import { type RouteObject, RouterProvider, createBrowserRouter } from 'react-router-dom';
import { UploadLandingView } from 'src/admin/views/UploadLandingView';
import { ErrorPage } from 'src/components/ErrorPage';
import { NavbarWithoutHeader } from 'src/components/Headers/NavbarWithoutHeader';

const uploadRoutes: Array<RouteObject> = [
  {
    path: '/upload',
    element: (
      <>
        <NavbarWithoutHeader />
        <UploadLandingView />
      </>
    ),
    errorElement: <ErrorPage />,
  },
];

const router = createBrowserRouter(uploadRoutes);

export const UploadRouter = () => {
  return <RouterProvider router={router} />;
};
